import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { supabase } from '../../lib/supabase';
import { pueblosPuertoRico } from '../../mocks/pueblos';

const tiposPropiedad = ['Casa', 'Apartamento', 'Solar', 'Local Comercial', 'Finca', 'Condominio', 'Townhouse'];

const mockPropiedades = [
  {
    id: 'mock-re-1',
    titulo: 'Casa 4 Hab / 3 Baños — Urb. Bairoa, Caguas',
    precio: 285000,
    pueblo: 'Caguas',
    habitaciones: 4,
    banos: 3,
    estacionamientos: 2,
    pies_cuadrados: 2200,
    tipo_propiedad: 'Casa',
    tipo_venta: 'precio_fijo',
    fotos: ['https://public.readdy.ai/ai/img_res/dcdf42d42ae4ad8de5fe86818151d0ab.jpg'],
    latitud: 18.2341,
    longitud: -66.0355,
    direccion_propiedad: 'Urb. Bairoa, Caguas, PR 00725',
  },
  {
    id: 'mock-re-2',
    titulo: 'Apartamento 2/1 — Condado, San Juan',
    precio: 245000,
    pueblo: 'San Juan',
    habitaciones: 2,
    banos: 1,
    estacionamientos: 1,
    pies_cuadrados: 950,
    tipo_propiedad: 'Apartamento',
    tipo_venta: 'precio_fijo',
    fotos: ['https://readdy.ai/api/search-image?query=modern%20luxury%20apartment%20interior%20living%20room%20ocean%20view%20Condado%20San%20Juan%20Puerto%20Rico%20contemporary%20design%20bright%20open%20space%20high%20rise%20building&width=700&height=500&seq=re-2&orientation=landscape'],
    latitud: 18.4574,
    longitud: -66.0726,
    direccion_propiedad: 'Condado, San Juan, PR 00907',
  },
  {
    id: 'mock-re-3',
    titulo: 'Solar 1,200 m² — Zona Residencial, Dorado',
    precio: 180000,
    pueblo: 'Dorado',
    habitaciones: null,
    banos: null,
    estacionamientos: null,
    pies_cuadrados: null,
    cuerdas: 0.3,
    tipo_propiedad: 'Solar',
    tipo_venta: 'precio_fijo',
    fotos: ['https://readdy.ai/api/search-image?query=empty%20residential%20land%20lot%20Puerto%20Rico%20tropical%20green%20grass%20clear%20sky%20palm%20trees%20neighborhood%20development%20real%20estate%20aerial%20view&width=700&height=500&seq=re-3&orientation=landscape'],
    latitud: 18.4579,
    longitud: -66.2697,
    direccion_propiedad: 'Urb. Dorado del Mar, Dorado, PR 00646',
  },
  {
    id: 'mock-re-4',
    titulo: 'Casa de Playa 3/2 — Rincón',
    precio: 420000,
    pueblo: 'Rincón',
    habitaciones: 3,
    banos: 2,
    estacionamientos: 2,
    pies_cuadrados: 1800,
    tipo_propiedad: 'Casa',
    tipo_venta: 'subasta',
    puja_actual: 395000,
    puja_count: 9,
    fecha_fin_subasta: new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).toISOString(),
    fotos: ['https://readdy.ai/api/search-image?query=stunning%20beachfront%20house%20Puerto%20Rico%20Rincon%20ocean%20view%20tropical%20paradise%20palm%20trees%20sunset%20luxury%20vacation%20home%20real%20estate%20photography&width=700&height=500&seq=re-4&orientation=landscape'],
    latitud: 18.3399,
    longitud: -67.2499,
    direccion_propiedad: 'Playa Rincón, Rincón, PR 00677',
  },
  {
    id: 'mock-re-5',
    titulo: 'Local Comercial 800 pies² — Mayagüez Mall Area',
    precio: 155000,
    pueblo: 'Mayagüez',
    habitaciones: null,
    banos: 1,
    estacionamientos: 4,
    pies_cuadrados: 800,
    tipo_propiedad: 'Local Comercial',
    tipo_venta: 'precio_fijo',
    fotos: ['https://readdy.ai/api/search-image?query=modern%20commercial%20retail%20space%20interior%20empty%20clean%20white%20walls%20Puerto%20Rico%20business%20property%20real%20estate%20professional%20photography&width=700&height=500&seq=re-5&orientation=landscape'],
    latitud: 18.2013,
    longitud: -67.1397,
    direccion_propiedad: 'Área Mayagüez Mall, Mayagüez, PR 00680',
  },
  {
    id: 'mock-re-6',
    titulo: 'Finca 15 Cuerdas con Río — Adjuntas',
    precio: 380000,
    pueblo: 'Adjuntas',
    habitaciones: null,
    banos: null,
    estacionamientos: null,
    cuerdas: 15,
    tipo_propiedad: 'Finca',
    tipo_venta: 'precio_fijo',
    fotos: ['https://readdy.ai/api/search-image?query=lush%20green%20Puerto%20Rico%20mountain%20farm%20finca%20river%20stream%20tropical%20forest%20hills%20panoramic%20aerial%20view%20agricultural%20land%20property&width=700&height=500&seq=re-6&orientation=landscape'],
    latitud: 18.1627,
    longitud: -66.7238,
    direccion_propiedad: 'Sector Río Prieto, Adjuntas, PR 00601',
  },
];

const BienesRaicesPage = () => {
  const [propiedades, setPropiedades] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [tipoProp, setTipoProp] = useState('');
  const [pueblo, setPueblo] = useState('');
  const [precioMax, setPrecioMax] = useState('');
  const [soloSubastas, setSoloSubastas] = useState(false);

  useEffect(() => {
    document.title = 'Bienes Raíces Puerto Rico | IslaVende - Casas, Apartamentos y Propiedades en PR';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', 'Encuentra casas, apartamentos, solares y fincas en Puerto Rico. El mejor sitio de clasificados de bienes raíces en PR. Publicación GRATIS, subastas de propiedades, contacto directo. Busca en los 78 municipios de la isla.');
  }, []);

  const fetchPropiedades = useCallback(async () => {
    setLoading(true);
    let query = supabase
      .from('products')
      .select('*')
      .eq('categoria', 'bienes_raices')
      .order('created_at', { ascending: false });

    if (tipoProp) query = query.eq('tipo_propiedad', tipoProp);
    if (pueblo) query = query.eq('pueblo', pueblo);
    if (precioMax) query = query.lte('precio', Number(precioMax));
    if (soloSubastas) query = query.eq('tipo_venta', 'subasta');

    const { data } = await query;
    setPropiedades(data || []);
    setLoading(false);
  }, [tipoProp, pueblo, precioMax, soloSubastas]);

  useEffect(() => {
    fetchPropiedades();
  }, [fetchPropiedades]);

  const displayData = propiedades.length > 0 ? propiedades : mockPropiedades;
  const filtered = displayData.filter(p => {
    if (tipoProp && p.tipo_propiedad !== tipoProp) return false;
    if (pueblo && p.pueblo !== pueblo) return false;
    if (precioMax && p.precio > Number(precioMax)) return false;
    if (soloSubastas && p.tipo_venta !== 'subasta') return false;
    return true;
  });

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      {/* Hero */}
      <div className="relative pt-20 overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: "url('https://readdy.ai/api/search-image?query=aerial%20panoramic%20view%20Puerto%20Rico%20coastline%20tropical%20island%20luxury%20real%20estate%20properties%20ocean%20mountains%20lush%20green%20landscape%20golden%20hour%20dramatic%20sky%20professional%20drone%20photography&width=1920&height=500&seq=re-hero&orientation=landscape')" }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/85 via-gray-900/60 to-gray-900/30" />
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 bg-emerald-500/20 border border-emerald-400/40 text-emerald-300 text-sm font-semibold px-4 py-1.5 rounded-full mb-5">
              <i className="ri-building-2-line text-base"></i>
              Bienes Raíces Puerto Rico
            </div>
            <h1 className="text-4xl sm:text-5xl font-extrabold text-white mb-4 leading-tight">
              Tu Próxima Propiedad<br />
              <span className="text-emerald-400">en la Isla</span>
            </h1>
            <p className="text-gray-300 text-lg mb-8">
              Casas, apartamentos, solares y fincas. Compra directa o en subasta de Derecho de Compra.
            </p>
            <div className="flex flex-wrap gap-6">
              {[
                { icon: 'ri-home-4-line', label: 'Propiedades', value: `${filtered.length}` },
                { icon: 'ri-auction-line', label: 'En Subasta', value: `${filtered.filter(p => p.tipo_venta === 'subasta').length}` },
                { icon: 'ri-map-pin-line', label: 'Municipios', value: '78' },
              ].map(stat => (
                <div key={stat.label} className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-lg">
                    <i className={`${stat.icon} text-xl text-emerald-400`}></i>
                  </div>
                  <div>
                    <p className="text-2xl font-bold text-white">{stat.value}</p>
                    <p className="text-xs text-gray-400">{stat.label}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Filtros */}
        <div className="bg-white rounded-2xl border border-gray-200 p-5 mb-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
            <div>
              <label className="block text-xs font-semibold text-gray-500 mb-1.5 uppercase tracking-wide">Tipo de Propiedad</label>
              <select
                value={tipoProp}
                onChange={e => setTipoProp(e.target.value)}
                className="w-full px-3 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:border-gray-400 cursor-pointer"
              >
                <option value="">Todos los tipos</option>
                {tiposPropiedad.map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-500 mb-1.5 uppercase tracking-wide">Pueblo</label>
              <select
                value={pueblo}
                onChange={e => setPueblo(e.target.value)}
                className="w-full px-3 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:border-gray-400 cursor-pointer"
              >
                <option value="">Todos los pueblos</option>
                {pueblosPuertoRico.map(p => <option key={p} value={p}>{p}</option>)}
              </select>
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-500 mb-1.5 uppercase tracking-wide">Precio Máximo</label>
              <input
                type="number"
                value={precioMax}
                onChange={e => setPrecioMax(e.target.value)}
                placeholder="Ej: 300000"
                className="w-full px-3 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:border-gray-400"
              />
            </div>
            <div className="flex items-end">
              <label className="flex items-center gap-3 cursor-pointer w-full p-3 border border-gray-200 rounded-xl hover:border-gray-300 transition-colors">
                <input
                  type="checkbox"
                  checked={soloSubastas}
                  onChange={e => setSoloSubastas(e.target.checked)}
                  className="w-4 h-4 accent-gray-900 cursor-pointer"
                />
                <div>
                  <p className="text-sm font-semibold text-gray-900 flex items-center gap-1.5">
                    <i className="ri-auction-line text-amber-500"></i>
                    Solo Subastas
                  </p>
                  <p className="text-xs text-gray-500">Derecho de Compra</p>
                </div>
              </label>
            </div>
          </div>
          <button
            onClick={() => { setTipoProp(''); setPueblo(''); setPrecioMax(''); setSoloSubastas(false); }}
            className="text-sm text-gray-500 hover:text-gray-700 font-medium cursor-pointer"
          >
            <i className="ri-refresh-line mr-1"></i>
            Limpiar filtros
          </button>
        </div>

        {loading ? (
          <div className="flex justify-center py-20">
            <div className="w-12 h-12 border-4 border-gray-900 border-t-transparent rounded-full animate-spin"></div>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map(prop => (
              <Link
                key={prop.id}
                to={`/producto/${prop.id}`}
                className="bg-white rounded-2xl overflow-hidden border-2 border-gray-100 hover:border-emerald-400 transition-all hover:-translate-y-1 cursor-pointer"
              >
                <div className="relative w-full h-52">
                  <img
                    src={prop.fotos?.[0] || 'https://readdy.ai/api/search-image?query=real%20estate%20property%20placeholder%20Puerto%20Rico%20house%20exterior%20clean%20professional%20photography&width=700&height=500&seq=re-placeholder&orientation=landscape'}
                    alt={prop.titulo}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />

                  <div className="absolute top-3 left-3 flex flex-wrap gap-2">
                    {prop.tipo_propiedad && (
                      <span className="bg-emerald-600 text-white text-xs font-bold px-2.5 py-1 rounded-full whitespace-nowrap">
                        {prop.tipo_propiedad}
                      </span>
                    )}
                    {prop.tipo_venta === 'subasta' && (
                      <span className="bg-amber-500 text-white text-xs font-bold px-2.5 py-1 rounded-full flex items-center gap-1 whitespace-nowrap">
                        <i className="ri-auction-line"></i>
                        Subasta
                      </span>
                    )}
                  </div>

                  <div className="absolute bottom-3 left-3 right-3 flex items-end justify-between">
                    <p className="text-white font-extrabold text-xl drop-shadow-lg">
                      ${prop.precio.toLocaleString()}
                    </p>
                    {prop.tipo_venta === 'subasta' && prop.puja_count > 0 && (
                      <span className="bg-black/60 text-white text-xs font-semibold px-2 py-1 rounded-full whitespace-nowrap">
                        {prop.puja_count} pujas
                      </span>
                    )}
                  </div>
                </div>

                <div className="p-5">
                  <h3 className="font-bold text-gray-900 text-sm mb-2 line-clamp-2 leading-snug">
                    {prop.titulo}
                  </h3>
                  <div className="flex items-center gap-1.5 text-xs text-gray-500 mb-4">
                    <i className="ri-map-pin-line"></i>
                    {prop.pueblo}
                  </div>

                  {/* Specs */}
                  <div className="flex flex-wrap gap-3">
                    {prop.habitaciones && (
                      <div className="flex items-center gap-1.5 text-xs text-gray-600 font-medium">
                        <div className="w-5 h-5 flex items-center justify-center">
                          <i className="ri-hotel-bed-line text-base text-gray-500"></i>
                        </div>
                        {prop.habitaciones} hab.
                      </div>
                    )}
                    {prop.banos && (
                      <div className="flex items-center gap-1.5 text-xs text-gray-600 font-medium">
                        <div className="w-5 h-5 flex items-center justify-center">
                          <i className="ri-drop-line text-base text-gray-500"></i>
                        </div>
                        {prop.banos} baños
                      </div>
                    )}
                    {prop.estacionamientos && (
                      <div className="flex items-center gap-1.5 text-xs text-gray-600 font-medium">
                        <div className="w-5 h-5 flex items-center justify-center">
                          <i className="ri-car-line text-base text-gray-500"></i>
                        </div>
                        {prop.estacionamientos} est.
                      </div>
                    )}
                    {prop.pies_cuadrados && (
                      <div className="flex items-center gap-1.5 text-xs text-gray-600 font-medium">
                        <div className="w-5 h-5 flex items-center justify-center">
                          <i className="ri-aspect-ratio-line text-base text-gray-500"></i>
                        </div>
                        {prop.pies_cuadrados.toLocaleString()} ft²
                      </div>
                    )}
                    {prop.cuerdas && (
                      <div className="flex items-center gap-1.5 text-xs text-gray-600 font-medium">
                        <div className="w-5 h-5 flex items-center justify-center">
                          <i className="ri-landscape-line text-base text-gray-500"></i>
                        </div>
                        {prop.cuerdas} cuerdas
                      </div>
                    )}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}

        {!loading && filtered.length === 0 && (
          <div className="text-center py-20">
            <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-5">
              <i className="ri-building-2-line text-4xl text-emerald-500"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">No hay propiedades con estos filtros</h3>
            <p className="text-gray-500 text-sm">Prueba ajustando los filtros</p>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default BienesRaicesPage;
